// dashboardEndpoints.ts
// API endpoints for user dashboard data (S14)

import { apiClient } from './client';

// S39: Performance summary types
export interface PerformancePeriod {
  amount: number;
  percent: number;
}

export interface PerformanceSummary {
  week: PerformancePeriod;
  month: PerformancePeriod;
  ytd: PerformancePeriod;
  all: PerformancePeriod;
}

// Types
export interface DashboardData {
  base_principal_cents: number;
  base_principal_dollars: string;
  ownership_percent: string;
  profit_week_cents: number;
  profit_week_dollars: string;
  reinvest_percent: number;
  withdrawable_cents: number;
  withdrawable_dollars: string;
  country: string;
  eligible_for_earnings: boolean;
  eligibility_status: string;
  contribution_shortfall_cents: number;
  contribution_shortfall_dollars: string;
  next_settlement: string;
  last_settlement: string | null;
  amount_to_reinvest_cents: number;
  amount_to_withdraw_cents: number;
  performance_summary?: PerformanceSummary;
}

// Endpoints
const dashboardEndpoints = {
  /**
   * Get complete dashboard data for current user
   */
  getDashboard: async (): Promise<DashboardData> => {
    return apiClient.get<DashboardData>('/api/dashboard');
  },
};

export default dashboardEndpoints;
